import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import Mark from '../../../domain/entities/Mark';

export default function reducer(
  state: {[key: number]: Mark} = {},
  action: AnyAction,
): {[key: number]: Mark} {
  switch (action.type) {
    case Types.IndexMarksSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Mark}, record: Mark) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowMarkSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
